export const ResultMatchType = {
  Label: 0,
  Description: 1,
} as const;
export type ResultMatchType = (typeof ResultMatchType)[keyof typeof ResultMatchType];

export interface ResultMatchProps {
  label?: string;
  indices?: readonly (readonly [number, number])[];
  highlightAll?: boolean;
  type?: ResultMatchType;
  disabled?: boolean;
  /** Clip the match to one line with an ellipsis when the parent is narrower than the text. */
  truncate?: boolean;
}
